import { useState, useEffect } from "react";
import type { LoginFormData } from "../store/types";
import { loginHandler } from "@/auth/login";
import { paths } from "@/navigation/paths";
import { authStore } from "../store";

export const useLogin = () => {
  const [formData, setFormData] = useState<LoginFormData>({
    phone: "",
    password: "",
  });
  const [fieldsErrors, setFieldsErrors] = useState<Record<string, string>>({});

  // Clear error when component mounts
  useEffect(() => {
    authStore.getState().setError(null);
  }, []);

  const setFieldErrorsHandler = (errors: Record<string, string>) => {
    setFieldsErrors((prevErrors) => ({ ...prevErrors, ...errors }));
  };

  const clearFieldErrorsHandler = () => {
    setFieldsErrors({});
  };

  const onChangeField = (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldName: keyof LoginFormData
  ) => {
    setFormData({ ...formData, [fieldName]: e.target.value });
  };

  const onChangePhoneField = (value: string) => {
    setFormData({ ...formData, phone: value });
  };

  const onSubmit = async (data: LoginFormData) => {
    authStore.getState().setLoading(true);
    try {
      const response = await loginHandler(data);
      if (response.data) {
        authStore.getState().setLogin(response.data);
        window.location.replace(paths.USER_BOOKINGS);
      } else {
        authStore.getState().setError(response.errorMessage);
      }
    } finally {
      authStore.getState().setLoading(false);
    }
  };

  return {
    formData,
    fieldsErrors,
    onSubmit,
    onChangeField,
    onChangePhoneField,
    setFieldErrorsHandler,
    clearFieldErrorsHandler,
  };
};
